export default "__VITE_ASSET__Bzj48wnl__"